import React from "react";
import CustomerCard from "./CustomerCard";
import CardDeck from "react-bootstrap/CardDeck";
const CustomerList = ({ customers }) => {
  return (
    <CardDeck style={{ flex: "none" }}>
      {customers.map((customer, i) => {
        // const merchant = merchants.merchantStats.find(
        //   merch => merch.id === uCustomers[i].merchant_id
        // );
        return (
          <CustomerCard
            key={i}
            id={customers[i].id}
            first_name={customers[i].first_name}
            last_name={customers[i].last_name}
            email={customers[i].email}
          />
        );
      })}
    </CardDeck>
  );
};

export default CustomerList;
